import type { Dispatch, SetStateAction } from 'react';
import type { CheckedStatus, ValidityStatus } from '../../../types';
import { isCreditOrDebitCardPayment, isGiftCardPayment } from '../../../utils/adyen';
import type { PaymentMethodTypes } from '../../../utils/adyen/adyen';

export interface StateStatus {
  valid: CheckedStatus | null;
  isValid: boolean;
  data: {
    paymentMethod: {
      type: string | null;
    };
  };
  errors: ValidityStatus;
}

interface HandleChangeProps {
  state: StateStatus;
  setIsPaymentBtnDisabled: Dispatch<SetStateAction<boolean>>;
  setIsErrorGiftCardInput: Dispatch<SetStateAction<boolean>>;
  setGiftCardStatus: Dispatch<SetStateAction<boolean>>;
  setPaymentError: Dispatch<SetStateAction<boolean>>;
  setValidityStatus: Dispatch<SetStateAction<ValidityStatus>>;
  setCheckedStatus: Dispatch<SetStateAction<CheckedStatus | null>>;
  setCustomerPaymentMethod: Dispatch<SetStateAction<PaymentMethodTypes | null>>;
}

export const handleChange = ({
  state,
  setValidityStatus,
  setCheckedStatus,
  setIsPaymentBtnDisabled,
  setIsErrorGiftCardInput,
  setGiftCardStatus,
  setPaymentError,
  setCustomerPaymentMethod,
}: HandleChangeProps) => {
  if (isCreditOrDebitCardPayment(state.data.paymentMethod.type as PaymentMethodTypes)) {
    setValidityStatus(state.errors);
  }

  setCheckedStatus(state.valid);
  setCustomerPaymentMethod(state.data.paymentMethod.type as PaymentMethodTypes);

  if (!isGiftCardPayment(state.data.paymentMethod.type as PaymentMethodTypes)) {
    setIsPaymentBtnDisabled(!state.isValid);
  } else if (isGiftCardPayment(state.data.paymentMethod.type as PaymentMethodTypes)) {
    const giftCardInputs = document.getElementsByClassName('adyen-checkout__input--error');

    setIsErrorGiftCardInput(!!giftCardInputs.length);
    setGiftCardStatus(state.isValid);
  }

  if (state.isValid) setPaymentError(false);
};
